import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
    selector: 'app-image-gallery-modal',
    template: `
        <div class="image-gallery-modal-container">
            <div class="image-gallery-header">
                <h3>{{ title }}</h3>
                <ion-button fill="clear" (click)="close()">
                    <ion-icon name="close"></ion-icon>
                </ion-button>
            </div>
            <div class="image-gallery-content">
                <div class="main-image-display">
                    <img [src]="currentImage?.image_url || currentImage?.url" 
                         [alt]="'Selected image'"
                         class="main-image" />
                    <div class="cover-badge" *ngIf="currentImage?.is_cover_image || currentImage?.is_cover_images">
                        <span>⭐ Cover Image</span>
                    </div>
                </div>
                <div class="thumbnail-grid">
                    <div *ngFor="let img of images; let i = index" 
                         class="thumbnail-item"
                         [class.selected]="i === selectedIndex"
                         [class.cover-image]="img.is_cover_image || img.is_cover_images"
                         (click)="selectImage(i)">
                        <img [src]="img.image_url || img.url" 
                             [alt]="'Image ' + (i + 1)"
                             class="thumbnail-img" />
                        <div class="cover-indicator" *ngIf="img.is_cover_image || img.is_cover_images">
                            <span>⭐</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `,
    styles: [`
        .image-gallery-modal-container {
            padding: 20px;
            max-height: 90vh;
            overflow-y: auto;
        }
        .image-gallery-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 20px;
            padding-bottom: 10px;
            border-bottom: 1px solid #e8e8e8;
        }
        .image-gallery-header h3 {
            margin: 0;
            font-size: 1.25rem;
            font-weight: 600;
        }
        .main-image-display {
            text-align: center;
            margin-bottom: 20px;
        }
        .main-image {
            max-width: 100%;
            max-height: 400px;
            object-fit: contain;
            border: 1px solid #d9d9d9;
            border-radius: 4px;
            padding: 8px;
            background: #fafafa;
        }
        .cover-badge {
            margin-top: 10px;
            display: inline-block;
            padding: 4px 12px;
            background: #faad14;
            color: white;
            border-radius: 4px;
            font-size: 12px;
        }
        .thumbnail-grid {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
            gap: 12px;
            max-height: 300px;
            overflow-y: auto;
        }
        .thumbnail-item {
            position: relative;
            cursor: pointer;
            border: 2px solid #d9d9d9;
            border-radius: 4px;
            overflow: hidden;
            padding: 2px;
            background: #fff;
            transition: all 0.3s;
        }
        .thumbnail-item:hover {
            border-color: #1890ff;
        }
        .thumbnail-item.selected {
            border: 3px solid #1890ff;
            background: #e6f7ff;
        }
        .thumbnail-img {
            width: 100%;
            height: 120px;
            object-fit: cover;
        }
        .cover-indicator {
            position: absolute;
            top: 4px;
            right: 4px;
            background: rgba(250, 173, 20, 0.9);
            color: white;
            padding: 2px 6px;
            border-radius: 2px;
            font-size: 10px;
        }
    `]
})
export class ImageGalleryModalComponent implements OnInit {
    @Input() images: any[] = [];
    @Input() title: string = 'Image Gallery';
    @Input() defaultIndex: number = 0;
    
    selectedIndex: number = 0;
    currentImage: any = null;

    constructor(private modalCtrl: ModalController) {}

    ngOnInit() {
        this.selectedIndex = this.defaultIndex;
        this.currentImage = this.images[this.selectedIndex];
    }

    selectImage(index: number) {
        this.selectedIndex = index;
        this.currentImage = this.images[index];
    }

    close() {
        this.modalCtrl.dismiss();
    }
}

